import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { contentAPI } from '../services/api';
import './PageDetail.css';

const PageDetail = () => {
  const { slug } = useParams();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadPage = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await contentAPI.getPage(slug);
        if (isMounted) {
          setPageData(response.data);
        }
      } catch (err) {
        if (isMounted) {
          setError(err?.response?.status === 404 ? 'Page not found.' : 'Unable to load page.');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadPage();

    return () => {
      isMounted = false;
    };
  }, [slug]);

  const title = pageData?.meta_title || pageData?.title || 'Information';
  const description =
    pageData?.meta_description ||
    'Additional information and resources from Automotive Care.';

  return (
    <>
      <Helmet>
        <title>{title} - Automotive Care</title>
        <meta name="description" content={description} />
      </Helmet>

      <div className="page-detail">
        <div className="page-detail-hero">
          <div className="container">
            <p className="page-detail-eyebrow">Information</p>
            <h1>{pageData?.title || 'Loading...'}</h1>
            <p className="page-detail-subtitle">
              Get the latest updates, policies, and helpful resources from the Automotive Care team.
            </p>
          </div>
        </div>

        <div className="page-detail-content">
          <div className="container">
            {loading && <div className="spinner" aria-label="Loading page content" />}
            {error && (
              <div className="page-detail-error">
                <p>{error}</p>
                <Link to="/contact" className="btn btn-primary">
                  Contact our team
                </Link>
              </div>
            )}
            {!loading && !error && pageData && (
              <article
                className="rich-text"
                dangerouslySetInnerHTML={{ __html: pageData.content || '' }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PageDetail;
